import { DecimalPipe, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsModule } from '@ngxs/store';
import { NgxMasonryModule } from 'ngx-masonry';
import { NgxStripeModule } from 'ngx-stripe';

import { environment } from '../environments/environment';
import { AuthGuard } from '../shared/guards/auth.guard';
import { SharedModule } from '../shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { componentsApp } from './components';
import { containersApp } from './containers';
import { httpInterceptorProviders } from './interceptors';
import { ServiceWorkerModule } from '@angular/service-worker';

registerLocaleData(localeFr);

export const createTranslateLoader = (http: HttpClient): TranslateHttpLoader => new TranslateHttpLoader(http, './assets/locales/', '.json');

@NgModule({
    declarations: [AppComponent, ...containersApp, ...componentsApp],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        NgxsModule.forRoot([], {
            developmentMode: !environment.production,
            selectorOptions: { suppressErrors: false, injectContainerState: true },
        }),
        SharedModule,
        NgxStripeModule.forRoot(),
        NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production }),
        NgxMasonryModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: environment.production,
          // Register the ServiceWorker as soon as the app is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        }),
    ],
    providers: [httpInterceptorProviders, AuthGuard, DecimalPipe, { provide: LOCALE_ID, useValue: 'fr-FR' }],

    bootstrap: [AppComponent],
})
export class AppModule {}
